import React, {PureComponent} from "react"
import styled from "styled-components"

import {getThumbnailImage} from "@irati/utils/images"
import BrandAvatar from "@irati/ui/src/BrandAvatar"

const Container = styled.div`
  margin-bottom: ${({theme}) => theme.spacing.two};

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    margin-bottom: 0;
    margin-right: ${theme.spacing.eight};
  `}
`

const Avatar = styled(BrandAvatar)`
  max-width: none;
  width: 80px;
  height: 80px;

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    width: 140px;
    height: 140px;
  `}
`

interface Props {
  thumbnailImage: string
}

export default class RewardAvatar extends PureComponent<Props> {
  render() {
    const {thumbnailImage} = this.props
    const thumbnail = getThumbnailImage(thumbnailImage)

    if (!thumbnail) return null

    return (
      <Container>
        <Avatar src={thumbnailImage} withShadow />
      </Container>
    )
  }
}
